import Vue from 'vue';
import HotReloadAPI from 'vue-hot-reload-api';
import { isDevelopment } from '@/utils/env';

const isHotReloadAvailable = !!HotReloadAPI;

if (isDevelopment && isHotReloadAvailable) {
    HotReloadAPI.install?.(Vue);
}

/**
 * Higher-order function that wraps a Vue component written in plain JS with HMR support. Only works in NODE_ENV=development.
 *
 * @param {object} module - The current module.
 * @param {object} component - The Vue component options.
 * @param {string} componentName - The unique name of the component.
 * @returns {object} The wrapped component.
 * @example
 * import withHMR from '@/utils/withHMR';
 * const WidgetSettingPanel = {
 *     name: 'WidgetSettingPanel',
 *     render() {
 *         return <div>Hello World</div>;
 *     },
 * }
 * export default withHMR(module, WidgetSettingPanel, WidgetSettingPanel.name);
 */
export default function withHMR(module, component, componentName) {
    if (isDevelopment && isHotReloadAvailable) {
        // Without this, the component cannot be updated with state preservation.
        if (!HotReloadAPI.isRecorded?.(componentName)) {
            console.log(
                `[HMR] Creating new record for component: ${componentName}`
            );
            HotReloadAPI.createRecord?.(componentName, component);
        } else {
            console.log(`[HMR] Reloading component: ${componentName}`);
            HotReloadAPI.reload?.(componentName, component);
        }

        // Without this, the component reload will bubble up.
        if (module.hot) {
            module.hot.accept?.();
            module.hot.dispose?.(() => {
                console.log(`[HMR] Disposing component: ${componentName}`);
            });
        }
    }
    return component;
}
